import { useCSRF } from '~/adapter/window/useCSRF';

export function CSRFHiddenInput() {
    const csrf = useCSRF();
    return <input type="hidden" name="authenticity_token" value={csrf} />;
}
